import {PageHeader, Skeleton} from '@sollapay/ui/components';

import type {FC} from 'react';

export const BuyerViewHeaderSkeleton: FC = () => {
  const breadcrumbSkeletonItems = [
    {key: 'crumb-home', widthClassName: 'w-4'},
    {key: 'crumb-trust-accounts', widthClassName: 'w-16'},
    {key: 'crumb-account-name', widthClassName: 'w-24'},
    {key: 'crumb-buyers', widthClassName: 'w-14'},
    {key: 'crumb-buyer-name', widthClassName: 'w-20'}
  ];
  const metaSkeletonItems = [
    {key: 'meta-date-of-birth', widthClassName: 'w-20'},
    {key: 'meta-national-id', widthClassName: 'w-24'},
    {key: 'meta-phone', widthClassName: 'w-16'},
    {key: 'meta-email', widthClassName: 'w-24'},
    {key: 'meta-address', widthClassName: 'w-28'}
  ];

  return (
    <PageHeader
      data-slot="buyer-view-header-skeleton"
      title=""
      titleNode={<Skeleton className="h-8 w-40" />}
      badge={<Skeleton className="h-5 w-24 rounded-full" />}
      breadcrumbs={
        <div className="flex items-center gap-2">
          {breadcrumbSkeletonItems.map((crumb, index) => (
            <div key={crumb.key} className="flex items-center gap-2">
              <Skeleton className={`h-4 ${crumb.widthClassName}`} />
              {index < breadcrumbSkeletonItems.length - 1 ? <Skeleton className="h-3 w-2" /> : null}
            </div>
          ))}
        </div>
      }
      description={
        <div className="flex items-center gap-6">
          {metaSkeletonItems.map(metaItem => (
            <div key={metaItem.key} className="flex items-center gap-2">
              <Skeleton className="size-4 rounded" />
              <Skeleton className={`h-4 ${metaItem.widthClassName}`} />
            </div>
          ))}
        </div>
      }
    />
  );
};
